import { render, staticRenderFns } from "./ResetPassword.vue?vue&type=template&id=5676e4aa&"
import script from "./ResetPassword.vue?vue&type=script&lang=js&"
export * from "./ResetPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/frontend/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5676e4aa')) {
      api.createRecord('5676e4aa', component.options)
    } else {
      api.reload('5676e4aa', component.options)
    }
    module.hot.accept("./ResetPassword.vue?vue&type=template&id=5676e4aa&", function () {
      api.rerender('5676e4aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "@shared/authentication/views/ResetPassword.vue"
export default component.exports